import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBZU3ymTfW_rFCFU8iAB2C9T89dA-qIe2E',
  authDomain: 'andika-online.firebaseapp.com',
  projectId: 'andika-online',
  storageBucket: 'andika-online.appspot.com',
  messagingSenderId: '930308776995',
  appId: '1:930308776995:web:57a62e825b65a8fc97bd96',
  measurementId: 'G-6YSH8LV3CB',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
